import { cn } from "@repo/lib";
import type { HTMLAttributes } from "react/jsx-runtime";

interface CardGroupValueProps {
  children: React.ReactNode;
  className?: string;
}

export const CardGroupValue = ({
  children,
  className,
}: CardGroupValueProps): JSX.Element => {
  return (
    <h3 className={cn("text-2xl text-neutral-600 font-medium", className)}>{children}</h3>
  );
};

interface CardGroupTitleProps {
  children: React.ReactNode;
  className?: string;
}

export const CardGroupLabel = ({
  children,
  className,
}: CardGroupTitleProps): JSX.Element => {
  return (
    <p className={cn("text-sm text-neutral-600 font-medium", className)}>{children}</p>
  );
};

interface CardGroupItemProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}

export const CardGroupItem = ({
  children,
  className,
  fullWidth = false,
}: CardGroupItemProps): JSX.Element => {
  const spanClasses = fullWidth ? "col-span-2 lg:col-span-1" : "";

  return (
    <div
      className={cn(
        "rounded-xl p-4 bg-white flex flex-col justify-start",
        spanClasses,
        className,
      )}
    >
      {children}
    </div>
  );
};

interface CardGroupRootProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  children: JSX.Element | JSX.Element[];
}

export const CardGroupRoot = ({
  className,
  children,
  ...props
}: CardGroupRootProps): JSX.Element => {
  return (
    <div className={cn("w-full", className)} {...props}>
      <div className="grid gap-4 grid-cols-2">{children}</div>
    </div>
  );
};
